export const APP_ROUTE_PATHS = {
  auth: "/auth",
  dashboard: "/dashboard",
  admin: "/admin",
  jobs: "/jobs",
  jobDetail: "/jobs/:jobId",
  processBuilder: "/process-builder",
  processBuilderDetail: "/process-builder/:jobId",
  calculator: "/calculator/:toolId",
  messages: "/messages",
  billing: "/billing",
  billingSuccess: "/billing/success",
  billingCancel: "/billing/cancel",
  billingReturn: "/billing/return",
  collaborativeProjects: "/collaborative-projects",
  featureRequest: "/request-custom-tool",
  platformFeatureRequests: "/platform-admin/feature-requests",
  ownerRequests: "/owner/requests",
};

export const CORE_SMOKE_ROUTES = [
  APP_ROUTE_PATHS.auth,
  APP_ROUTE_PATHS.dashboard,
  APP_ROUTE_PATHS.admin,
  APP_ROUTE_PATHS.jobs,
  APP_ROUTE_PATHS.jobDetail,
  APP_ROUTE_PATHS.calculator,
  APP_ROUTE_PATHS.billing,
  APP_ROUTE_PATHS.billingSuccess,
  APP_ROUTE_PATHS.billingCancel,
  APP_ROUTE_PATHS.billingReturn,
];
